import React from 'react';

import QuestionsContainer from '@ts-core/modules/exercises/components/QuestionsContainer';
import MultipleChoiceQuestionPreview from '@ts-core/modules/multipleChoiceExercises/components/MultipleChoiceQuestionPreview';
import ExercisePreviewContainer from '@ts-core/modules/exercises/components/ExercisePreviewContainer';

import { MultipleChoiceExerciseWithResults } from '../../types';

interface MultipleChoiceExercisePreviewProps {
  exercise?: MultipleChoiceExerciseWithResults;
  loading?: boolean;
  hideNoAnswerOption?: boolean;
  hideScores?: boolean;
  hideQuestionBackgroundColor?: boolean;
}

const MultipleChoiceExercisePreview = (props: MultipleChoiceExercisePreviewProps) => {
  const { exercise, loading = false, hideNoAnswerOption = false, hideScores = false, hideQuestionBackgroundColor = false } = props;

  return (
    <ExercisePreviewContainer exercise={exercise} layout="row" loading={loading}>
      <QuestionsContainer
        questions={exercise?.questions}
        loading={loading}
        renderQuestion={(index, question) => (
          <MultipleChoiceQuestionPreview
            key={question?._id || index}
            hideScores={hideScores}
            hideNoAnswerOption={hideNoAnswerOption}
            question={question}
            loading={loading}
            hideQuestionBackgroundColor={hideQuestionBackgroundColor}
          />
        )}
      />
    </ExercisePreviewContainer>
  );
};

export default MultipleChoiceExercisePreview;
